import styled from "@emotion/styled";
import InnoIcons from "@InnoIcons/";
import theme from "@theme/";

const Container = styled.div`
  border-radius: 8px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

const QuickSearchSection = styled.div`
  margin-bottom: 20px;
`;

const QuickSearchLabel = styled.span`
  color: black;
  font-weight: 500;
  margin-right: 16px;
  font-size: 18px;
`;

const TabContainer = styled.div`
  display: inline-flex;
  gap: 0;
`;

const Tab = styled.button`
  background: ${(props) =>
    props.active ? theme.gradient.themeGradient : "#f9fafb"};
  color: ${(props) => (props.active ? "white" : "#374151")};
  border: 1px solid
    ${(props) => (props.active ? theme.colors.themeColor : "#ffff")};
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 8px;
  margin-right: 6px;
  transition: all 0.3s ease;
  box-shadow: ${(props) =>
    props.active ? "0 2px 6px rgba(217, 119, 6, 0.3)" : "none"};

  &:hover {
    background: ${(props) =>
      props.active ? "linear-gradient(135deg, #ea580c, #b45309)" : "#f3f4f6"};
    color: ${(props) => (props.active ? "white" : theme.colors.themeColor)};
    transform: translateY(-1px);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(217, 119, 6, 0.4);
  }
`;

// const SearchRow = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 12px;
//   margin-bottom: 20px;
//   justify-content: space-between;
// `;

const SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
`;

const LeftControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1.5;
  min-width: 0;

  @media (max-width: 1024px) {
    flex-wrap: wrap;
  }

  @media (max-width: 768px) {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    flex: 2;
  }
`;

// const SearchInput = styled.input`
//   padding: 10px 16px;
//   border: 2px solid #e5e7eb;
//   border-radius: 6px;
//   font-size: 14px;
//   background: white;
//   width: 40%;

//   &:focus {
//     outline: none;
//     border-color: ${theme.colors.themeColor};
//   }
// `;

const SearchInput = styled.input`
  padding: 10px 16px;
  border: 2px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  flex: 1;
  min-width: 220px;

  &:focus {
    outline: none;
    border-color: ${theme.colors.themeColor};
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;

// const AdvancedOptionsButton = styled.button`
//   position: relative; /* ✅ Needed for absolute positioning of badge */
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: ${theme.gradient.themeGradient};
//   color: white;
//   border: none;
//   padding: 10px 20px;
//   height: 40px;
//   border-radius: 6px;
//   font-size: 14px;
//   font-weight: 500;
//   width: 100%;
//   cursor: pointer;
//   transition: background 0.2s ease;

//   &:hover {
//     background: ${theme.gradient.themeGradient};
//   }
// `;

const AdvancedOptionsButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.gradient.themeGradient};
  color: white;
  border: none;
  padding: 10px 16px;
  height: 40px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Badge = styled.span`
  position: absolute;
  top: -6px; /* Adjust as needed */
  right: -6px; /* Adjust as needed */
  background: ${theme.colors.modernInfo};
  color: white;
  border-radius: 50%;
  padding: 4px 7px;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
`;

const SavedFiltersContainer = styled.div`
  margin-left: auto;
`;

// const SavedFiltersDropdown = styled.button`
//   background: white;
//   border: 2px solid #e5e7eb;
//   padding: 10px 16px;
//   border-radius: 6px;
//   font-size: 14px;
//   cursor: pointer;
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   min-width: 140px;
//   justify-content: space-between;

//   &:hover {
//     border-color: #d1d5db;
//   }
// `;

const SavedFiltersDropdown = styled.button`
  background: white;
  border: 2px solid #e5e7eb;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 160px;
  justify-content: space-between;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const FilterSection = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  position: relative; /* ✅ allows absolute positioning inside */
`;

const CornerIcon = styled.div`
  position: absolute;
  top: 8px; /* distance from top */
  right: 8px; /* distance from right */
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background-color: #fff;
  cursor: pointer;
`;

const FilterTitle = styled.h3`
  color: black;
  font-weight: 500;
  margin-right: 16px;
  font-size: 18px;
`;

const FilterRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

const FilterDropdown = styled.button`
  background: white;
  border: 2px solid #e5e7eb;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 180px;
  justify-content: space-between;

  &:hover {
    border-color: #d1d5db;
  }
`;

const FilterActions = styled.div`
  display: flex;
  gap: 12px;
`;

const FilterButton = styled.button`
  background: ${(props) =>
    props.variant === "primary" ? `${theme.colors.themeColor}` : "#EFEFEF"};
  color: ${(props) => (props.variant === "primary" ? "#017BD3" : "black")};
  border: 2px solid #ffff;
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) =>
      props.variant === "primary" ? "#CDEEFF" : "#CDEEFF"};
    color: #017bd3;
  }
`;

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #888;
  font-size: 20px;
`;

const InputStyle = styled.input`
  width: 100%;
  padding: 8px 8px 8px 35px;
  height: 40px;
  font-size: 13px;
  border: 1px solid ${theme.colors.themeColor};
  border-radius: 8px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
`;

const SavedFilterContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
`;

const CardContainer = styled.div`
  background: ${theme.gradient.backgroundTheme};
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 16px;
`;

const SC = {
  Container,
  QuickSearchSection,
  QuickSearchLabel,
  TabContainer,
  Tab,
  SearchRow,
  SearchInput,
  AdvancedOptionsButton,
  SavedFiltersContainer,
  SavedFiltersDropdown,
  FilterSection,
  FilterTitle,
  FilterRow,
  FilterDropdown,
  FilterActions,
  FilterButton,
  InputContiner,
  SearchIcon,
  InputStyle,
  CornerIcon,
  Badge,
  LeftControls,
  SavedFilterContainer,
  CardContainer,
};

export default SC;
